import { useTranslation } from 'react-i18next';
import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { useOtpService } from 'app/utils/services/otpService';
import useRedirectWithFormId from 'app/utils/customHooks/useRedirectWithFormId';
import logger from 'app/utils/logger';

const useOTP = () => {
  const { t } = useTranslation();
  const [otp, setOtp] = useState<string>();

  const navigate = useNavigate();
  const location = useLocation();
  const data = location.state;
  const lang = location.pathname.substring(0, 3);

  const [timer, setTimer] = useState(0);

  const { isSuccessOtp, isLoadingOtp, dataOtp, otpMutation } = useOtpService();
  const { handleRedirect } = useRedirectWithFormId();
  const { handleSubmit } = useForm({});

  useEffect(() => {
    if (dataOtp?.form_id === 'get_company') {
      handleRedirect({ ...dataOtp, tab: data.tab });
    }

    if (dataOtp?.form_id === 'otp') {
      setTimer(dataOtp?.timer);
    }

    if (dataOtp?.form_id === 'set_password') {
      handleRedirect(dataOtp);
    }
  }, [dataOtp]);

  const handleChange = (newOtp: string) => {
    setOtp(newOtp);
  };

  const resentOtp = () => {
    otpMutation({ data: { form_id: 'renew_otp' }, url: `${data?.path_url}?business_key=${data?.business_key}` });
  };

  const handleOnSubmit = () => {
    otpMutation({ data: { otp }, url: `${data?.path_url}?business_key=${data?.business_key}` });
  };

  const goBack = () => {
    navigate(-1);
  };

  const handleSubmitForm = handleSubmit(handleOnSubmit);

  return {
    t,
    otp,
    data,
    isLoadingOtp,
    dataOtp,
    handleChange,
    handleSubmitForm,
    goBack,
    resentOtp,
    timer,
    isSuccessOtp,
  };
};

export default useOTP;
